import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row importance" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("label", null, "Importance")
], -1 /* HOISTED */);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", { for: "essential" }, "Essential", -1 /* HOISTED */);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("label", { for: "basic" }, "Basic", -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", { for: "advanced" }, "Advanced", -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { for: "expert" }, "Expert", -1 /* HOISTED */);
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableImportanceInput',
    props: {
        importance: {}
    },
    emits: ["update:importance"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const importanceProxy = computed({
            get() {
                return props.importance;
            },
            set(value) {
                emit("update:importance", value);
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "essential",
                    value: "ESSENTIAL",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((importanceProxy).value = $event))
                }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, importanceProxy.value]
                ]),
                _hoisted_3,
                _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "basic",
                    value: "BASIC",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((importanceProxy).value = $event))
                }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, importanceProxy.value]
                ]),
                _hoisted_4,
                _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "advanced",
                    value: "ADVANCED",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((importanceProxy).value = $event))
                }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, importanceProxy.value]
                ]),
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "expert",
                    value: "EXPERT",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((importanceProxy).value = $event))
                }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, importanceProxy.value]
                ]),
                _hoisted_6
            ]));
        };
    }
});
